"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _filerobotImageEditor = _interopRequireDefault(require("filerobot-image-editor"));

require("tui-image-editor/dist/tui-image-editor.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SnekStudio = function SnekStudio(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_filerobotImageEditor["default"], {
    config: {
      translations: {
        en: {
          'header.image_editor_title': 'Snek Studio'
        }
      },
      language: 'en',
      finishButtonLabel: 'Save',
      tools: ['adjust', 'effects', 'filters', 'rotate', 'crop', 'resize', 'watermark', 'shapes', 'image', 'text', 'focus_point'],
      replaceCloseWithBackButton: true
    },
    show: true,
    src: props.src,
    onClose: props.onClose,
    onComplete: function onComplete(_ref) {
      var canvas = _ref.canvas;
      canvas.toBlob(function (blob) {
        props.onComplete(blob, canvas.toDataURL('image/png'));
      });
    },
    onBeforeComplete: function onBeforeComplete() {
      return false;
    }
  });
};

var _default = SnekStudio;
exports["default"] = _default;